import * as _ from "lodash";
export class ExternalDatasetManagementPageComponent implements ng.IComponentOptions {
  public controller: any = ExternalDatasetManagementController;
  public template: string =
  `
    <h2>External Dataset Management</h2>
    <table class="table table-hover table-striped">
    <thead>
    <tr>
    <th>Name</th><th>Organisation</th><th>Created By</th><th></th>
    </tr>
    </thead>
    <tbody>
      <tr ng-repeat="dataset in $ctrl.datasets"><td><a ng-href="#/dataset/{{dataset._id}}" target="_blank">{{dataset.display_name}}</a></td><td>{{dataset.organization}}</td><td>{{dataset.user.email}}</td><td><button class="btn btn-primary" ng-click="$ctrl.approve(dataset._id)">Approve</button></td></tr>
    </tbody>
    </table>
  `;
}

export class ExternalDatasetManagementController {
  public static $inject: Array<string> = ['$http'];
  public datasets: Array<any>;
  constructor (private $http: ng.IHttpService) {}
  public $onInit() {
      this.getData();
  }
  public approve(id) {
    if (id) {
      let data:any = _.find(this.datasets, {_id: id});
      swal({
        type: "warning",
        title: "Are you sure?",
        text: `You want to approve ${data.display_name} from ${data.organization}?`,
        showCancelButton: true
      }, (confirm) => {
        this.$http.put(`${BASE}/api/external_dataset/${id}`, {approve: true}).then(() => {
          this.getData();
        })
        .catch((err) => {
          swal('Sorry!', 'Unexpected error just happen. Please try again', 'error');
        })
      })
    }
  }
  public getData() {
    this.$http.get(`${BASE}/api/external_dataset`).then((data:any) => {
      this.datasets = data.data;
    })
  }
}
